/**
 * Buyer questions, written to answer the real objections before checkout.
 * Plain words, no dashes. Health answers stay within what evidence and
 * FSSAI advertising rules allow: no cure or prevention claims.
 */

export const HOME_FAQS = [
  {
    q: "What does cold pressed coconut oil mean?",
    a: "The oil is pressed out of the coconut mechanically without adding heat, and it is not refined afterwards. It keeps its natural coconut aroma and taste. Refined coconut oil, sold as RBD, is heated, bleached and deodorised so it tastes of nothing.",
  },
  {
    q: "How do I know Karijeeva is pure?",
    a: "Three ways. Every batch is tested at an independent food testing lab, and our latest sample met the FSSAI standard for coconut oil on all six purity tests, including acid value and the argemone oil test. Our FSSAI licence number is 11226304000242, which you can check on the FSSAI website. And you can write to us with the batch number printed on your jar to get the lab report for that exact batch.",
  },
  {
    q: "Why has my oil turned white and solid?",
    a: "Pure coconut oil sets solid below about 24°C. It is not spoiled. Keep the jar in a warm spot or stand it in a bowl of warm water for a few minutes and it turns clear again.",
  },
  {
    q: "Why does Karijeeva come in a jar and not a bottle?",
    a: "Because coconut oil sets. Below about 24°C it turns white and solid, and getting solid oil out of a narrow bottle means warming the whole bottle or digging at the neck. A wide jar lets you scoop exactly what you need with a clean, dry spoon, in any season.",
  },
  {
    q: "Can I cook everyday Indian food with it?",
    a: "Yes. It suits tadka, poriyal, thoran, dosa, appam, upma and baking, and it keeps the coconut flavour these dishes are known for. Cook at medium heat and don't reuse oil that has been used for deep frying.",
  },
  {
    q: "Why does it cost more than regular coconut oil?",
    a: "We grow our own coconuts, press them in small batches, never refine the oil to stretch it, and pay for a lab test on every batch. Refined oil is cheaper because it can be made from any copra, from anywhere.",
  },
  {
    q: "Is it safe for baby massage?",
    a: "It is a single ingredient oil with nothing added, which is why many Indian families choose coconut oil for baby massage. Do a small patch test first, and speak to your paediatrician if your baby has very sensitive skin or eczema.",
  },
  {
    q: "Is coconut oil healthy?",
    a: "Coconut oil has been a cooking fat in South Indian kitchens for generations, and cold pressed oil keeps the natural coconut taste and aroma that refining strips out. It is also high in saturated fat (89 g per 100 g in our latest lab report), so like any oil, use it in sensible amounts. India's national nutrition institute (ICMR NIN) suggests using a mix of oils in your kitchen, and Karijeeva is an honest choice for the coconut oil in that mix.",
  },
  {
    q: "How long does delivery take, and can I return it?",
    a: "We dispatch within 24 to 48 hours and deliver across India, usually in 3 to 7 business days. Delivery is free above ₹998. Unopened jars can be returned within 7 days of delivery, and if a jar arrives damaged we replace it or refund you in full.",
  },
];
